import axios from "axios";
import { getLoginDataFromStorage } from "../helpers/storage";

export const https = (baseURL = "") => {
  const instance = axios.create({
    //baseURL: `http://localhost:9090${baseURL}`,
    baseURL: `https://api-matricula.qi.edu.br${baseURL}`,
    timeout: 1800000, // 30 min
    headers: {
      "x-access-token": getLoginDataFromStorage().token
    }
  });
  return instance;
};
